import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Modal from 'antd/lib/modal'
import AcknowledgeForm from './AcknowledgeForm'
import TenantEstimatedEmployees from './EstimatedEmployees'
import { getLatestAcknowledgements } from '../Reports/Acknowledgement/Utils'

const TenantConfigurator = ({ acknowledgement, population, loading }) => {
    const [showAcknowledgement, setShowAcknowledgement] = useState(false)
    const [showPopulation, setShowPopulation] = useState(false)

    useEffect(() => {
        if (!loading) {
            const ack = getLatestAcknowledgements(acknowledgement)
            if (!ack || !ack.active || ack.declined) {
                setShowAcknowledgement(true)
            }
            if ((!population || population.estimated === 0) && acknowledgement) {
                setShowPopulation(true)
            } else {
                setShowPopulation(false)
            }
        }
    }, [acknowledgement, population, loading])

    const onAcknowledged = () => {
        setShowAcknowledgement(false)

        if (!population || population.estimated === 0) {
            setShowPopulation(true)
        }
    }

    const onEstimatedPopulationUpdated = (item) => {
        if (item.data) {
            setShowPopulation(false)
        }
    }

    return (
        <Modal
            title={acknowledgement ? 'BSS Tenant Activation Policy' : 'Tenant Setup'}
            visible={showAcknowledgement || showPopulation}
            onOk={() => Modal.error({ title: 'Please complete the action to proceed.' })}
            onCancel={() => Modal.error({ title: 'Please complete the action to proceed.' })}
            footer={false}
        >
            {showAcknowledgement && <AcknowledgeForm callback={onAcknowledged} />}
            {showPopulation && <TenantEstimatedEmployees onUpdate={onEstimatedPopulationUpdated} />}
        </Modal>
    )
}

export default TenantConfigurator
